import { maxBy } from "lodash-es";
import { defineStore } from "pinia";
import type { ICartActiveCoupon, ICartCouponData, ICartSuggestedCoupon, ICartSuggestedCouponOption } from "~~/types/cart";

export const useCartCouponStore = defineStore('cart-coupon', () => {

    const coupons = shallowRef<ICartSuggestedCoupon[]>([]);
    const activeCoupon = shallowRef<ICartActiveCoupon | null>();

    function setCoupons(value: ICartCouponData) {
        coupons.value = value.suggested.map<ICartSuggestedCoupon>((el) => ({
            code: el.code,
            details: el.details,
            priority: el.priority,
            variants: el.variants.map<ICartSuggestedCouponOption>((v) => {

                const date = v.activeTo ? new Date(v.activeTo) : null;
                const pTypes = v.payTypes?.length ? new Set(v.payTypes) : null;

                return {
                    activeTo: date,
                    discountTypes: v.discountTypes,
                    id: v.id,
                    minOrder: v.minOrder,
                    payTypes: pTypes,
                    suggestType: v.suggestType,
                    value: v.value
                }
            })
        }))

        activeCoupon.value = value.active;
    }

    const availableCouponBadges = computed(() => {

        const result: {i: number, v: number, c: string}[] = [];

        for (let i = 0; i <=4; i++) {

            const options: [number, string][] = [];

            coupons.value.forEach((el) => {

                const availableOptions = el.variants.filter(
                    (e) => (e.suggestType & 4) && !(e.discountTypes && !(e.discountTypes & (1 << i))));

                if (!availableOptions.length) {
                    return;
                }

                options.push([availableOptions[0]!.value, el.code]);
            });

            if (options.length) {
                const max = maxBy(options, 0);
                result.push({i: i, v: max![0], c: max![1]});
            }
        }

        return result;
    });

    return { coupons, activeCoupon, setCoupons, availableCouponBadges };
});
